import { useMemo } from "react";
import { useLocation, useOutletContext, useParams } from "react-router-dom";

import EmployeeImportForm from "./EmployeeImportForm";
import { buildImportOverviewPath, getEmployeeImportRecordView, IMPORT_TABS, withoutEmployeeImportDetailState } from "./importNavigation";

export default function EmployeeImportDetail() {
  const { id } = useParams();
  const location = useLocation();
  const { helps } = useOutletContext();

  const backTo = useMemo(() => {
    const params = new URLSearchParams(withoutEmployeeImportDetailState(location.search));
    if (!params.get("tab")) {
      params.set("tab", IMPORT_TABS.employees);
    }
    return buildImportOverviewPath(params.toString());
  }, [location.search]);

  const initialRecordFilter = useMemo(() => {
    return getEmployeeImportRecordView(location.search);
  }, [location.search]);

  return (
    <div className="col-lg col-md-9 section-col-right d-flex">
      <div className="bg-white w-100 p-4 content-card">
        <EmployeeImportForm id={id} imports={[]} helps={helps} backTo={backTo} initialRecordFilter={initialRecordFilter} />
      </div>
    </div>
  );
}
